// extracted by mini-css-extract-plugin
export default {"modal-overlay":"ModalOverlay-module__modal-overlay__GvzXY"};